import PropTypes from 'prop-types';
import { config } from 'config';
import i18n from 'i18nextInstance';
import orderBy from 'lodash/orderBy';
import { useLocalstorage } from 'hooks';
import { useTranslation } from 'react-i18next';
import { Flag, SelectSearch } from 'mol-ui';
import { FlagContainer, OptionContainer } from './styled';
import React, { useCallback, useEffect } from 'react';
const { availableLanguages, defaultLanguage } = config;

const LanguagePicker = ({
    onChange = () => null
}) => {

    const { t } = useTranslation();
    const [selectedLanguage, setSelectedLanguage] = useLocalstorage('i18nextLng');

    const languages = orderBy([{
        flag: 'ES',
        label: t('Español'),
        value: 'es'
    }, {
        flag: 'US',
        label: t('Inglés'),
        value: 'en'
    }].filter(({ value }) => availableLanguages.includes(value)), 'label');

    useEffect(() => {
        if (selectedLanguage?.length > 2) {
            setSelectedLanguage(selectedLanguage.substring(0, 2));
        } else if (!selectedLanguage) {
            setSelectedLanguage(defaultLanguage);
        }
    }, [selectedLanguage, setSelectedLanguage]);

    const findFlag = flag => languages.find(({ value }) => value === flag)?.flag ?? '--';

    const customControl = useCallback(({ children }) => (
        <>
            <FlagContainer margin="0px 0px 2px 10px">
                <Flag country={ findFlag(selectedLanguage) } />
            </FlagContainer>
            { children }
        </>
    ), [findFlag, selectedLanguage]);

    const customOption = ({ children, data: { value } }) => (
        <OptionContainer>
            <FlagContainer margin="0px 10px 2px 0px">
                <Flag country={ findFlag(value) } />
            </FlagContainer>
            { children }
        </OptionContainer>
    );

    const handleLanguageChange = value => {
        i18n.changeLanguage(value);
        onChange(value);
        setSelectedLanguage(value);
    };

    return (
        <SelectSearch
            customControl={ customControl }
            customOption={ customOption }
            options={ languages }
            value={ selectedLanguage }
            width="100%"
            onChange={ handleLanguageChange }
        />
    );
};

LanguagePicker.propTypes = {
    onChange: PropTypes.func
};

export default LanguagePicker;
